import { RouterProvider } from "react-router-dom";

import { startTransition, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setColor, setTheme } from "./GlobalSlice/theme.slice";
import router from "./routes/router";
import { useGetTheme } from "./service";
import { ToastContainer } from "./UI-Components/Toast/ToastContainer";
import { ThemeProvider } from "./context/ThemeContext";
import PosLoader from "./Components/Loader/PosLoader";
import { setBrokerData } from "./GlobalSlice/broker.slice";
import BrokerIcon from "@/assets/images/fyntune_favicon.ico";

function App() {
  const dispatch = useDispatch();
  const { theme: userTheme } = useSelector((state) => state.theme);

  const { data, isPending } = useGetTheme();

  useEffect(() => {
    const broker = data?.data?.broker || {};
    const faviconUrl = broker?.favicon_icon || BrokerIcon;

    if (data?.data?.status === 200) {
      const lightColor =
        (data?.data?.return_data[0]?.primaryColor?.slice(0, 7) || "##ff0000") +
        "1a";
      dispatch(setTheme(data?.data?.return_data[0]));
      dispatch(setBrokerData(data?.data?.broker));
      dispatch(setColor({ lightColor }));
      if (broker?.favicon_icon) {
        const link =
          document.querySelector("link[rel~='icon']") ||
          document.head.appendChild(document.createElement("link"));

        link.rel = "icon";
        link.href = faviconUrl;
      }
      startTransition(() => {
        document.documentElement.style.setProperty(
          "--color-primary",
          data?.data?.return_data[0]?.primaryColor || "#ff0000",
        );
        document.documentElement.style.setProperty(
          "--color-secondary",
          data?.data?.return_data[0]?.secondaryColor || "#dd9292",
        );
        document.documentElement.style.setProperty(
          "--color-tertiary",
          data?.data?.return_data[0]?.tertiaryColor || "#ffffff",
        );
        document.documentElement.style.setProperty("--light-color", lightColor);
      });
    }
  }, [data]);

  if (isPending) {
    return <PosLoader />;
  }

  return (
    <ThemeProvider
    // theme={{
    //   // ...theme,
    //   ...userTheme,
    // }}
    >
      <div className="selection:bg-primary/20 selection:text-black selection: font-medium">
        <RouterProvider router={router} />
      </div>
      <ToastContainer />
    </ThemeProvider>
  );
}

export default App;
